export const SOCIAL_SERVICE_NAMES = {
  FACEBOOK: 'socialservice.name.facebook',
  LINKED_IN: 'socialservice.name.linkedin',
  TWITTER: 'socialservice.name.twitter',
  INSTAGRAM: 'socialservice.name.instagram',
  PINTEREST: 'socialservice.name.pinterest',
  YOU_TUBE: 'socialservice.name.youtube',
  MAIL: 'socialservice.name.mail',
  HOME_PAGE: 'socialservice.name.homepage',
}

export const SOCIAL_SERVICE_KEYS = Object.keys(SOCIAL_SERVICE_NAMES)
  .map((key) => ({ [key]: `${key}` }))
  .reduce((result, current) => ({ ...result, ...current }), {})

export const SOCIAL_ICONS_CDN =
  'https://cdn.getanewsletter.com/blockeditor/social-icons/'

export const SOCIAL_ICONS = {
  [SOCIAL_SERVICE_KEYS.FACEBOOK]: 'facebook',
  [SOCIAL_SERVICE_KEYS.LINKED_IN]: 'linkedin',
  [SOCIAL_SERVICE_KEYS.TWITTER]: 'x',
  [SOCIAL_SERVICE_KEYS.INSTAGRAM]: 'instagram',
  [SOCIAL_SERVICE_KEYS.PINTEREST]: 'pinterest',
  [SOCIAL_SERVICE_KEYS.YOU_TUBE]: 'youtube',
  [SOCIAL_SERVICE_KEYS.MAIL]: 'mail',
  [SOCIAL_SERVICE_KEYS.HOME_PAGE]: 'homepage',
}

export const SOCIAL_SERVICE_SHARE_LINKS = {
  [SOCIAL_SERVICE_KEYS.FACEBOOK]: 'https://www.facebook.com/sharer/sharer.php?u=##newsletter##',
  [SOCIAL_SERVICE_KEYS.LINKED_IN]:
    'http://www.linkedin.com/shareArticle?mini=true&url=##newsletter##',
  [SOCIAL_SERVICE_KEYS.TWITTER]: 'https://x.com/intent/tweet/?url=##newsletter##',
  [SOCIAL_SERVICE_KEYS.INSTAGRAM]: null,
  [SOCIAL_SERVICE_KEYS.PINTEREST]: null,
  [SOCIAL_SERVICE_KEYS.YOU_TUBE]: null,
  [SOCIAL_SERVICE_KEYS.MAIL]: 'mailto:?body=##title##%0D%0A##newsletter##',
  [SOCIAL_SERVICE_KEYS.HOME_PAGE]: null,
}

export const SOCIAL_SERVICE_DISABLE_FOLLOW = {
  [SOCIAL_SERVICE_KEYS.MAIL]: true,
}

export const defaultSettings = {
  align: 'center',
  design: 'color',
  size: 'medium',
}
